export default "__VITE_ASSET__D$JAMhp8__"